module.exports = __webpack_public_path__ + "static/media/strattic-illustration.249aa0ef.png";